module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_1/brain-52a951bc8dee8d2483780ae4386de0c3.jpeg";